import { FC } from 'react'
import { Flex } from '@/components/atoms/Grid'
import { Tiny } from '@/components/atoms/typography'
import styled, { css } from 'styled-components'
import { validFor } from '@/theme/validFor'

type BadgeProps = {
  counter: number
} & Rest

const Badge: FC<BadgeProps> = ({ counter, ...rest }) => {
  return (
    <StyledFlex data-testid="badge" {...rest}>
      <StyledBadgeText>{counter}</StyledBadgeText>
    </StyledFlex>
  )
}

export const BadgeRedesign: FC<BadgeProps> = ({ counter, ...rest }) => {
  return (
    <StyledFlexRedesign data-testid="badge" {...rest}>
      <StyledBadgeText>{counter}</StyledBadgeText>
    </StyledFlexRedesign>
  )
}

export const BigBadgeRedesign: FC<BadgeProps> = ({ counter, ...rest }) => {
  return (
    <StyledBigBageWrapperRedesign data-testid="big-badge" {...rest}>
      <StyledBadgeTextRedesign>{counter}</StyledBadgeTextRedesign>
    </StyledBigBageWrapperRedesign>
  )
}

export default Badge

const WrapperBase = css`
  justify-content: center;
  align-items: center;
  min-width: 19px;
  height: 19px;
  border-radius: 19px;
  ${validFor.tablet` 
    min-width: 15px;
    height: 15px;
    border-radius: 15px; 
	`};
  ${validFor.mobile` 
    min-width: 13px;
    height: 13px;
    border-radius: 13px;  
	`};
  background: ${(props) => props.theme.colors.accent};
`

const WrapperBaseRedesign = css`
  justify-content: center;
  align-items: center;
  min-width: 19px;
  height: 19px;
  border-radius: 19px;
  ${validFor.tablet` 
    min-width: 18px;
    height: 18px;
    border-radius: 18px; 
	`};
  ${validFor.mobile` 
    min-width: 16px;
    height: 16px;
    border-radius: 16px;  
	`};
  background: ${(props) => props.theme.colors.navMenuRed};
`

const StyledFlex = styled(Flex)`
  ${WrapperBase};
  padding: 0;
  ${validFor.tablet`
    border: 1px solid ${(props) => props.theme.colors.background};
  `}
  ${validFor.mobile` 
    border: 1px solid ${(props) => props.theme.colors.onBackground};
	`};
`

const StyledFlexRedesign = styled(Flex)`
  ${WrapperBaseRedesign};
  padding: 0;
  ${validFor.tablet`
    border: 1px solid ${(props) => props.theme.colors.background};
  `}
  ${validFor.mobile` 
    border: 1px solid ${(props) => props.theme.colors.onBackground};
	`};
`

const StyledBigBageWrapperRedesign = styled(Flex)`
  ${WrapperBaseRedesign};
  padding: 3px;
`

const StyledBadgeText = styled(Tiny)`
  margin: 0;
  color: white;
  justify-self: center;
  line-height: normal;
  text-align: center;
  align-self: center;
  margin-block-start: 0;
  margin-block-end: 0;
  ${validFor.tablet` 
    font-size: 9.6px;
	`};
  ${validFor.mobile` 
    font-size: 9.6px;
	`};
`

const StyledBadgeTextRedesign = styled(Tiny)`
  margin: 0;
  color: white;
  justify-self: center;
  line-height: normal;
  text-align: center;
  align-self: center;
  margin-block-start: 0;
  margin-block-end: 0;
  ${validFor.tablet` 
    font-size: 12px;
	`};
  ${validFor.mobile` 
    font-size: 12px;
	`};
`
